/**
 * Maps i18n → Stripe `locale` for create-checkout-session / create-portal-session.
 * Docs: https://docs.stripe.com/api/checkout/sessions#create_checkout_session-locale
 * Omitting `locale` → Stripe uses auto (browser / customer).
 * When adding a language: map here + add tag to `_STRIPE_UI_LOCALES` in backend/stripe_integration/views.py.
 */
export function stripeLocaleFromAppLang(lang) {
	if (!lang || typeof lang !== 'string') return undefined
	const base = lang.split(/[-_]/)[0].toLowerCase()
	// Must match App.js languageOptions / navbar.
	if (base === 'fr') return 'fr'
	if (base === 'en') return 'en'
	return undefined
}
